module.exports = __webpack_public_path__ + "static/media/exchange-small.be66bbb3.svg";